import React, { useRef, useEffect, useState } from "react";

// LazyImage bileşeni
interface ThemeLazyImageProps {
  src: string;
  alt: string;
}

const ThemeLazyImage: React.FC<ThemeLazyImageProps> = ({ src, alt }) => {
  const imgRef = useRef<HTMLImageElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 },
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);

  return <img ref={imgRef} src={isVisible ? src : ""} alt={alt} />;
};

export default ThemeLazyImage;
